// extracted by mini-css-extract-plugin
module.exports =  {"role":"JvikqZ3Fh1sndOVRGQbI","userEmail":"qaeDtDQByd7Tk6CvjV1F","selectionCheckbox":"JWOSRi1PnyqOnL4nsCKv"};